import React from 'react'
import { Box } from '@usap/uicomponents'
import { commaSeparetedValue } from '@usap/core'
import { SummaryDarkerItem } from '../SummaryWmo.css'

const CoreWmo = props => {
  const { data } = props

  return (
    <Box direction="row" justify="between">
      <SummaryDarkerItem>
        Core Charge:
      </SummaryDarkerItem>

      <SummaryDarkerItem data-testid='cart-summary-core-price'>
        $
        {commaSeparetedValue(parseFloat(data.coreTotal))}
      </SummaryDarkerItem>
    </Box>
  )
}

export default CoreWmo
